import styled from '@emotion/styled'
import { Container, Grid, GridProps, Paper } from '@mui/material'
import { headerMDHeight } from '../Header/constants'
import { theme as newTheme } from 'styles/theme/hav-theme'
import { css } from '@emotion/react'

interface GridStyled extends GridProps {
  // TODO: Replace with type string with boolean type
  fullwidth: 'true' | 'false'
}

export const PaperStyled = styled(Paper)`
  min-height: 100vh;
  background-color: ${newTheme.colors.quartenary};
  justify-content: center;
  display: flex;
  box-shadow: none;

  @media only screen and (max-width: ${newTheme.breakpoints.md}px) {
    :first-of-type {
      display: flex;
      align-items: center;
    }
  }
`

export const Main = styled('main')`
  flex-grow: 1;
`

export const WrapContainerStyled = styled(Container)`
  ${({ header, fullwidth }: { header: number; fullwidth: 'true' | 'false' }) =>
    `
      padding-top: ${header ? headerMDHeight : 0}px;

      @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
        padding-top: ${header ? headerMDHeight : 0}px;
      }
      @media (min-width: ${newTheme.breakpoints.xl}px){
        max-width:${fullwidth === 'true' ? '100vw' : '1440px'};

      }
  `}
`

export const GridContainerStyled = styled(Grid)`
  min-height: calc(100vh - ${headerMDHeight}px);
  justify-content: flex-start;

  @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
    min-height: 100vh;
  }
`

export const GridContentStyled = styled(Grid)<GridStyled>`
  max-width: ${({ fullwidth }) => (fullwidth ? '100%' : '1440px !important')};
  min-width: ${({ fullwidth }) => (fullwidth ? '100%' : '1440px')};
  margin: 0 auto;
  padding: ${({ fullwidth }) =>
    fullwidth ? `${newTheme.spacing.xm} ${newTheme.spacing.xm}` : 0};

  @media only screen and (max-width: 1440px) {
    ${({ fullwidth }) =>
      fullwidth === 'false' &&
      css`
        max-width: 100vw !important;
        min-width: 100vw;
      `}
  }
`
